{
    "Profile_Terms.terms": "Terms",
    "Profile_Terms.term": "Term: {term}",
    "Profile_Terms.policyNumber": "Policy Number: {number}",
    "Profile_Terms.transactionType": "Transaction Type",
    "Profile_Terms.effectiveDate": "Effective Date",
    "Profile_Terms.expiryDate": "Expiry Date",
    "Profile_Terms.premium": "Premium",
    "Profile_Terms.taxes": "Taxes",
    "Profile_Terms.fees": "Fees",
    "Profile_Terms.total": "Total",
    "Profile_Terms.status": "Status",
    "Profile_Terms.totalLabel": "Total:"
}
